import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';
import { truncate } from 'lodash';
import { useTranslation } from 'react-i18next';

const colorClass = {
  primary: 'primary-color',
  secondary: 'secondary-color',
  success: 'success-color',
  danger: 'danger-color',
  disabled: 'text-color-unknown',
};
export function ValueUnitInfo(props) {
  const {
    ellipsis,
    info,
    maxInfoLength,
    showDegree,
    type,
    unit,
    value,
    valueClassName,
    unitClassName
  } = props;

  const formattedInfo = ellipsis ? truncate(info, { length: maxInfoLength }) : info;
  const { t } = useTranslation();
  const isCWSI = unit === 'CWSI';
  const isMedStress = value === 'MED STRESS';
  const textWrap = typeof value === 'number' || value === '-/-' ? 'text-nowrap' : 'text-normal';

  return (
    <span className="value-unit-info flex-column map-valve-info">
      <span className="value-container flex-row">
        <Typography.Title
          level={2}
          className={`${isCWSI || isMedStress ? `value-text-med-crop-stress ${colorClass[type]} ${valueClassName}`
            : `value-text ${colorClass[type]}`} ${textWrap} ${valueClassName}`}
        >
          {typeof value === 'number' && isCWSI ? value.toFixed(2) : value }
        </Typography.Title>
        <span className="flex-row text-nowrap">
          <Typography.Text
            strong
            className={`unit-text ${colorClass[type]} ${showDegree ? 'degree' : ''} ${unitClassName}`}
          >
            {t(unit)}
          </Typography.Text>
        </span>
      </span>
      <Typography.Text type="secondary" className="info-text">{t(formattedInfo)}</Typography.Text>
    </span>
  );
}

ValueUnitInfo.defaultProps = {
  ellipsis: false,
  info: '',
  showDegree: false,
  maxInfoLength: 15,
  type: 'primary',
  unit: '',
  value: '',
  unitClassName: '',
  valueClassName: '',
};

ValueUnitInfo.propTypes = {
  ellipsis: PropTypes.bool,
  info: PropTypes.string,
  maxInfoLength: PropTypes.number,
  showDegree: PropTypes.bool,
  type: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger']),
  unit: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  unitClassName: PropTypes.string,
  valueClassName: PropTypes.string,
};
